import { useState } from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';

import { useMsal } from "@azure/msal-react";
import { notification } from 'antd';

import { OrderSummary } from '../../api-client';
import { OrderApiClient } from '../../providers/api-provider';
import { initCustomerOrders } from '../../slices/Customer/customerOrdersSlice';

export const useCustomerOrders = () => {
    const {
        instance
    } = useMsal();

    const dispatch = useDispatch();

    const [ordersSummary, setOrdersSummary] = useState<OrderSummary[]>();
    const [ordersSummaryLoading, setOrdersSummaryLoading] = useState<boolean>(false);

    const handleOrdersSummary = async (orderFilter: any, callback?: () => void) => {
        setOrdersSummaryLoading(true);

        const clientApi = await OrderApiClient(instance);

        clientApi.getOrdersSummaryByFilter(orderFilter)
            .then((response) => {
                setOrdersSummary(response.data);

                dispatch(initCustomerOrders(response.data));

                callback && callback();
            })
            .catch((reason) => {
                setOrdersSummary([]);

                notification.error({
                    message: 'Unable to retrieve customer orders!',
                    description: 'Unable to retrieve customer orders.',
                    duration: 2
                });
            })
            .finally(() => {
                setOrdersSummaryLoading(false);
            });
    }

    return {
        handleOrdersSummary,
        ordersSummary,
        ordersSummaryLoading
    }
}